import { render } from "./ClubDealBuyChat.vue?vue&type=template&id=a8df2d38&scoped=true&ts=true"
import script from "./ClubDealBuyChat.vue?vue&type=script&lang=ts"
export * from "./ClubDealBuyChat.vue?vue&type=script&lang=ts"

import "./ClubDealBuyChat.vue?vue&type=style&index=0&id=a8df2d38&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8df2d38"]])

export default __exports__